import { connect } from 'react-redux';
import { useState } from 'react';


const PoweredByBar = () => {
  return (
    <div className='bg-[#471cff] text-white py-[6px] px-[14px] leading-[1em]'>
      <div className='flex relative'>
        <div className='flex flex-col'>
          <div 
            className='flex gap-x-1'
            onMouseEnter={() => {}}
            onMouseLeave={() => {}}
          >
            <p className='italic font-extralight'>Powered by:</p>
            <p className='font-bold'>{process.env.REACT_APP_BUSINESS_NAME}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = state => { return { // define redux state that will be passed in as props
}};
export default connect(mapStateToProps, {})(PoweredByBar);
